import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { storeQueries, MmcDataSourceInitializer } from '@bingads-webui-campaign-react/merchant-shared';
import { siteMapPropType, withToolsSiteMap, processorSet } from '@bingads-webui-campaign-react/with-site-map';
import { StyledSubPageMenu } from '@bingads-webui-campaign-react/sub-page-menu';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';
import { MmcNotificationTopBanner } from '@bingads-webui-campaign-react/merchant-center-notification';

const StyledIssuesCount = (props) => {
  const { issuesCount } = props;

  return (
    <span
      style={{
        color: '#323130',
        marginLeft: 4,
        background: '#F3F2F1',
        fontSize: 12,
        borderRadius: '50%',
        width: 28,
        height: 28,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {issuesCount}
    </span>
  );
};

StyledIssuesCount.propTypes = {
  issuesCount: PropTypes.number.isRequired,
};

const MmcStoreSummarySubPageMenu = (props) => {
  const {
    scope: {
      values: {
        storeId,
      },
    },
  } = props;
  const [issuesCounts, setIssuesCounts] = useState({});

  useEffect(() => {
    if (storeId) {
      storeQueries.getIssuesCount(storeId)
        .then(mtResponse => setIssuesCounts({
          productIssues: mtResponse.ProductIssues,
          feedIssues: mtResponse.FeedIssues,
          storeIssues: mtResponse.StoreIssues,
        }));
    }
  }, [storeId]);

  const onTabItemRender = (item) => {
    const {
      productIssues, feedIssues, storeIssues,
    } = issuesCounts;

    if ((productIssues || productIssues === 0) && item.id === 'mmc-store-summary-productissues') {
      return (<StyledIssuesCount issuesCount={productIssues} />);
    } else if ((feedIssues || feedIssues === 0) && item.id === 'mmc-store-summary-feedissues') {
      return (<StyledIssuesCount issuesCount={feedIssues} />);
    } else if ((storeIssues || storeIssues === 0) && item.id === 'mmc-store-summary-storeissues') {
      return (<StyledIssuesCount issuesCount={storeIssues} />);
    }

    return null;
  };

  const {
    productIssues, feedIssues, storeIssues,
  } = issuesCounts;

  return (
    <StyledSubPageMenu
      key={`${productIssues}-${feedIssues}-${storeIssues}`}
      {...props}
      onTabItemRender={onTabItemRender}
    />
  );
};

MmcStoreSummarySubPageMenu.propTypes = {
  scope: PropTypes.instanceOf(QueryParam).isRequired,
};

export const Loader = (props) => {
  const {
    siteMap,
    updateAvailability,
    permissions,
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const available = !_.isEmpty(selectedParent);

  useEffect(() => {
    updateAvailability(available);
  });

  return (
    <React.Fragment>
      <MmcDataSourceInitializer {...props} />
      { props.isVisible ?
        <Scenario name="sub-page-memu">
          <Activity name="mmc-sub-page-memu">
            {permissions.dynamic.FeedLabelGmcMigration && !permissions.dynamic.FeedLabelBlockList && <MmcNotificationTopBanner />}
            {selectedParent && selectedParent.id === 'mmc-store-summary' ? (
              <MmcStoreSummarySubPageMenu {...props} />
            ) : (
              <StyledSubPageMenu {...props} selectedParent={selectedParent && selectedParent.id} />
            )}
          </Activity>
        </Scenario> : null }
    </React.Fragment>
  );
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
  changeLayout: PropTypes.func.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      FeedLabelGmcMigration: PropTypes.bool,
      FeedLabelBlockList: PropTypes.bool,
    }),
  }).isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const MmcStoreSubPageMenuLoader = withToolsSiteMap(
  React.memo(Loader),
  processorSet.all,
  [
    'mmc-store-summary/mmc-store-summary',
    'mmc-stores',
    'mmc-feeds',
    'mmc-promotions',
    'mmc-import/mmc-import',
    'mmc-settings/mmc-settings',
    'mmc-products',
  ]
);
